module.exports = __webpack_public_path__ + "img/bg_icon_4.33c84fd4.svg";